import * as actionTypes from './redux.actionTypes';

// Fetch all goals with filters and pagination
export const fetchGoals = (params) => ({
    type: actionTypes.FETCH_GOALS,
    payload: params
});

export const fetchGoalsSuccess = (payload) => ({
    type: actionTypes.FETCH_GOALS_SUCCESS,
    payload
});

export const fetchGoalsFailure = (error) => ({
    type: actionTypes.FETCH_GOALS_FAILURE,
    payload: error
});

// Fetch goal by ID
export const fetchGoalById = (id) => ({
    type: actionTypes.FETCH_GOAL_BY_ID,
    payload: { id }
});

export const fetchGoalByIdSuccess = (payload) => ({
    type: actionTypes.FETCH_GOAL_BY_ID_SUCCESS,
    payload
});

export const fetchGoalByIdFailure = (error) => ({
    type: actionTypes.FETCH_GOAL_BY_ID_FAILURE,
    payload: error
});

// Create goal
export const createGoal = (payload) => ({
    type: actionTypes.CREATE_GOAL,
    payload
});

export const createGoalSuccess = (payload) => ({
    type: actionTypes.CREATE_GOAL_SUCCESS,
    payload
});

export const createGoalFailure = (error) => ({
    type: actionTypes.CREATE_GOAL_FAILURE,
    payload: error
});

// Update goal
export const updateGoal = (id, payload) => ({
    type: actionTypes.UPDATE_GOAL,
    payload: { id, data: payload }
});

export const updateGoalSuccess = (payload) => ({
    type: actionTypes.UPDATE_GOAL_SUCCESS,
    payload
});

export const updateGoalFailure = (error) => ({
    type: actionTypes.UPDATE_GOAL_FAILURE,
    payload: error
});

// Delete goal
export const deleteGoal = (id) => ({
    type: actionTypes.DELETE_GOAL,
    payload: { id }
});

export const deleteGoalSuccess = (id) => ({
    type: actionTypes.DELETE_GOAL_SUCCESS,
    payload: { id }
});

export const deleteGoalFailure = (error) => ({
    type: actionTypes.DELETE_GOAL_FAILURE,
    payload: error
});

// Dialog management
export const openGoalDialog = (goal = null) => ({
    type: actionTypes.OPEN_GOAL_DIALOG,
    payload: goal
});

export const closeGoalDialog = () => ({
    type: actionTypes.CLOSE_GOAL_DIALOG
});

export const openDeleteDialog = (goal) => ({
    type: actionTypes.OPEN_DELETE_DIALOG,
    payload: goal
});

export const closeDeleteDialog = () => ({
    type: actionTypes.CLOSE_DELETE_DIALOG
});

// Set selected goal
export const setSelectedGoal = (goal) => ({
    type: actionTypes.SET_SELECTED_GOAL,
    payload: goal
});

// Set filters and pagination
export const setFilters = (filters) => ({
    type: actionTypes.SET_FILTERS,
    payload: filters
});

export const setPagination = (pagination) => ({
    type: actionTypes.SET_PAGINATION,
    payload: pagination
});

export const setSort = (sort) => ({
    type: actionTypes.SET_SORT,
    payload: sort
});

// Open goal usage dialog
export const openGoalUsageDialog = (usageData) => ({
    type: actionTypes.OPEN_GOAL_USAGE_DIALOG,
    payload: usageData
});

export const closeGoalUsageDialog = () => ({
    type: actionTypes.CLOSE_GOAL_USAGE_DIALOG
});

// Fetch departments
export const fetchDepartments = () => ({
    type: actionTypes.FETCH_DEPARTMENTS
});

export const fetchDepartmentsSuccess = (payload) => ({
    type: actionTypes.FETCH_DEPARTMENTS_SUCCESS,
    payload
});

export const fetchDepartmentsFailure = (error) => ({
    type: actionTypes.FETCH_DEPARTMENTS_FAILURE,
    payload: error
});
